import{lazy,Suspense}from'react';
import{Navigate,Route,Routes}from'react-router-dom';
import{Box,CircularProgress}from'@mui/material';
import{getSession}from'./api';
import AppShell from'./AppShell';

const Login=lazy(()=>import('./pages/LoginPage'));
const TrialRegistration=lazy(()=>import('./pages/TrialRegistrationPage'));
const Overview=lazy(()=>import('./pages/OverviewPage'));
const Projects=lazy(()=>import('./pages/ProjectsPage'));
const SmartProject=lazy(()=>import('./pages/SmartProjectPage'));
const ProjectOperations=lazy(()=>import('./pages/ProjectPage'));
const Attention=lazy(()=>import('./pages/AttentionPage'));
const Resources=lazy(()=>import('./pages/ResourcesPage'));
const Finance=lazy(()=>import('./pages/FinancePage'));
const Billing=lazy(()=>import('./pages/BillingPage'));
const Executive=lazy(()=>import('./pages/ExecutivePage'));
const SteerCo=lazy(()=>import('./pages/SteerCoPage'));
const Roadmap=lazy(()=>import('./pages/RoadmapPage'));
const Platform=lazy(()=>import('./pages/PlatformPage'));
const PlatformCommercial=lazy(()=>import('./pages/PlatformCommercialPage'));
const PlatformOnboarding=lazy(()=>import('./pages/PlatformOnboardingPage'));

const AdminLayout=lazy(()=>import('./pages/AdminLayout'));
const AdminOverview=lazy(()=>import('./pages/AdminOverviewPage'));
const AdminRules=lazy(()=>import('./pages/AdminProjectRulesPage'));
const AdminProjectManagement=lazy(()=>import('./pages/AdminProjectManagementPage'));
const AdminResource=lazy(()=>import('./pages/AdminResourcePage'));
const AdminCommercial=lazy(()=>import('./pages/AdminCommercialPage'));
const AdminReporting=lazy(()=>import('./pages/AdminReportingPage'));
const AdminPilotReadiness=lazy(()=>import('./pages/AdminPilotReadinessPage'));
const ProjectTemplates=lazy(()=>import('./pages/ProjectTemplatesPage'));
const Integration=lazy(()=>import('./pages/IntegrationPage'));
const Organisation=lazy(()=>import('./pages/OrganisationPage'));
const Access=lazy(()=>import('./pages/AccessPage'));
const Audit=lazy(()=>import('./pages/AuditPage'));

const Loading=()=>
 <Box display="grid" minHeight="50vh" sx={{placeItems:'center'}}>
  <CircularProgress/>
 </Box>;

function Gate(){
 return getSession()
  ?<AppShell/>
  :<Navigate to="/login" replace/>;
}

function Home(){
 return getSession()?.kind==='platform'
  ?<Navigate to="/platform" replace/>
  :<Overview/>;
}

export default function App(){
 return <Suspense fallback={<Loading/>}>
  <Routes>
   <Route path="/login" element={<Login/>}/>
   <Route path="/trial" element={<TrialRegistration/>}/>
   <Route element={<Gate/>}>
    <Route index element={<Home/>}/>
    <Route path="projects" element={<Projects/>}/>
    <Route path="projects/:id" element={<SmartProject/>}/>
    <Route path="projects/:id/operations" element={<ProjectOperations/>}/>
    <Route path="attention" element={<Attention/>}/>
    <Route path="resources" element={<Resources/>}/>
    <Route path="finance" element={<Finance/>}/>
    <Route path="billing" element={<Billing/>}/>
    <Route path="executive" element={<Executive/>}/>
    <Route path="steerco" element={<SteerCo/>}/>
    <Route path="roadmap" element={<Roadmap/>}/>

    <Route path="admin" element={<AdminLayout/>}>
     <Route index element={<AdminOverview/>}/>
     <Route path="organisation" element={<Organisation/>}/>
     <Route path="project-templates" element={<ProjectTemplates/>}/>
     <Route path="project-management" element={<AdminProjectManagement/>}/>
     <Route path="project-intelligence" element={<AdminRules/>}/>
     <Route path="resources" element={<AdminResource/>}/>
     <Route path="commercial" element={<AdminCommercial/>}/>
     <Route path="reporting" element={<AdminReporting/>}/>
     <Route path="pilot-readiness" element={<AdminPilotReadiness/>}/>
     <Route path="project-rules" element={<Navigate to="/admin/project-intelligence" replace/>}/>
     <Route path="data-integration" element={<Integration/>}/>
     <Route path="access" element={<Access/>}/>
     <Route path="audit" element={<Audit/>}/>
    </Route>

    <Route path="project-templates" element={<Navigate to="/admin/project-templates" replace/>}/>
    <Route path="integration" element={<Navigate to="/admin/data-integration" replace/>}/>
    <Route path="organisation" element={<Navigate to="/admin/organisation" replace/>}/>
    <Route path="access" element={<Navigate to="/admin/access" replace/>}/>
    <Route path="audit" element={<Navigate to="/admin/audit" replace/>}/>

    <Route path="platform" element={<Platform/>}/>
    <Route path="platform/subscriptions" element={<PlatformCommercial/>}/>
    <Route path="platform/organisations/:id/onboarding" element={<PlatformOnboarding/>}/>
   </Route>
   <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes>
 </Suspense>;
}
